import { gql } from '@apollo/client'

export default gql`
  mutation updateProject($id: ID!, $sectionIds: [ID]!) {
    updateProject(id: $id, sectionIds: $sectionIds) {
      id
      sections {
        id
        name
      }
    }
  }
`
